import { isDefined } from "@clipboard-health/util-ts";
import { isBefore } from "date-fns";

export function checkMissedPunchWarning(
  selectedTime: Date,
  workerClockIn: Date | undefined,
  isGeofenceFacility: boolean,
  isNfcOrMeshFacility: boolean
): { isValid: boolean; warningType?: "MISSED_PUNCH_WARNING"; message?: string } | undefined {
  // Only applies to facilities with timekeeping systems
  if (!isGeofenceFacility && !isNfcOrMeshFacility) {
    return undefined;
  }

  // Warning if workerClockIn is not set
  if (!isDefined(workerClockIn)) {
    return createMissedPunchWarningResult();
  }

  // Warning if selected time is earlier than workerClockIn
  if (isBefore(selectedTime, workerClockIn)) {
    return createMissedPunchWarningResult();
  }

  return undefined;
}

function createMissedPunchWarningResult(): {
  isValid: boolean;
  warningType: "MISSED_PUNCH_WARNING";
  message: string;
} {
  return {
    isValid: true,
    warningType: "MISSED_PUNCH_WARNING",
    message:
      "You are recording a missed punch. No worries - you'll be able to add the reason on the next screen.",
  };
}
